import type { ReactNode } from "react";
import { TbArrowLeft } from "react-icons/tb";
import { useNavigate } from "react-router-dom";
import CarePlusShippingFAQ from "../../CarePlusShared/CarePlusShippingFAQ";
import CarePlusStepper from "../../CarePlusShared/CarePlusStepper";
import { Translate } from "../../ChoosePlanCarePlus/planContent";
import "./ShippingV3CarePlus.css";

// The V3 shell owns only Figma composition. ShippingV2 stays the data and interaction owner.

interface ShippingV3CarePlusProps {
  t: Translate;
  addressForm: ReactNode;
  couponControl: ReactNode;
  cartSummary: ReactNode;
  costBreakdown: ReactNode;
  cta: ReactNode;
  /** False hides the Care+ FAQ (the UK funnel has no Care+). */
  showFaq?: boolean;
}

const ShippingV3CarePlus = ({
  t,
  addressForm,
  couponControl,
  cartSummary,
  costBreakdown,
  cta,
  showFaq = true,
}: ShippingV3CarePlusProps) => {
  const navigate = useNavigate();

  return (
    <section className="shipping-v3-care-plus" aria-label={t("shipping", "Shipping")}>
      <div className="shipping-v3-care-plus__progress" aria-label="Checkout progress">
        <button type="button" className="shipping-v3-care-plus__back" aria-label="Back" onClick={() => navigate(-1)}>
          <TbArrowLeft size={22} aria-hidden="true" />
        </button>
        <div className="shipping-v3-care-plus__stepper">
          <CarePlusStepper current="checkout" t={t} compact variant="white" />
        </div>
        <div className="shipping-v3-care-plus__header-spacer" aria-hidden="true" />
      </div>

      <h1 className="shipping-v3-care-plus__title">{t("shipping", "Shipping")}</h1>

      <div className="shipping-v3-care-plus__content">
        <div className="shipping-v3-care-plus__address">{addressForm}</div>
        <div className="shipping-v3-care-plus__coupon">{couponControl}</div>
        <div className="shipping-v3-care-plus__summary">{cartSummary}</div>
        <div className="shipping-v3-care-plus__breakdown">{costBreakdown}</div>
        <div className="shipping-v3-care-plus__cta">{cta}</div>
        {showFaq && (
          <div className="shipping-v3-care-plus__faq">
            <CarePlusShippingFAQ t={t} />
          </div>
        )}
      </div>
    </section>
  );
};

export default ShippingV3CarePlus;
